"use client";
import { Button } from "@/components/ui/button";
import { useWinnersCtx } from "@/contexts/winners";
import {
  DropDownIcon,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "@/i18n/client";
import { useLocaleCtx } from "@/contexts/locale";

export default function TopBar() {
  const { category, setCategory, categories } = useWinnersCtx();

  return (
    <>
      {/* <MobileItems /> */}

      <div className="relative mx-auto hidden sm:block">
        <div className="flex w-screen overflow-hidden overflow-x-auto border border-primary/20 px-6 py-2 sm:w-fit sm:justify-center sm:gap-4 sm:rounded-full sm:px-10 sm:py-2">
          {categories?.map((cat) => {
            const isActive = cat.title === category.title;

            return (
              <div key={cat.title} className="relative">
                {isActive && (
                  <div className="absolute inset-x-0 -bottom-2 z-10 h-[1px] bg-primary sm:-bottom-2" />
                )}
                <Button
                  variant="ghost"
                  onClick={() =>
                    setCategory({
                      title: cat.title,
                      value: cat.value,
                    })
                  }
                  className={`relative z-20 rounded-none text-xs 2xl:text-base ltr:font-opensans ${isActive ? "" : "opacity-40"}`}
                >
                  {cat.title}
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export function MobileItems() {
  const { category, setCategory, categories } = useWinnersCtx();
  const { lang } = useLocaleCtx();
  const { t } = useTranslation(lang, "common");

  return (
    <div className="flex items-center gap-2 sm:hidden">
      <div className="flex-shrink-0 text-sm text-secondary/40 ltr:font-opensans">
        {t("filterBy")}:
      </div>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger className="h-12 w-full rounded-full bg-foreground px-4 text-sm text-secondary sm:py-3">
          <div className="flex items-center justify-between gap-2 text-xs sm:text-sm ltr:font-opensans">
            {category.title}
            <DropDownIcon />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="bg-foreground text-secondary">
          {categories?.map((cat) => (
            <DropdownMenuItem
              key={cat.title}
              className="cursor-pointer ltr:font-opensans"
              onClick={() =>
                setCategory({
                  title: cat.title,
                  value: cat.value,
                })
              }
            >
              {cat.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
